<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Shape</title>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-1371.000000, -25.000000)" fill="#000000">
        <g transform="translate(1241.000000, 25.000000)">
          <g transform="translate(130.000000, 0.000000)">
            <path
              d="M5.24556,1.78615385 C5.006862,1.78615385 4.777947,1.88024843 4.609161,2.04772715 L3.072762,3.57230769 L16.72722,3.57230769 L15.19083,2.04772715 C15.02199,1.88024843 14.79312,1.78615385 14.55435,1.78615385 L5.24556,1.78615385 Z M17.88048,5.35846154 L1.919475,5.35846154 L3.395934,17.0792031 C3.452229,17.5261881 3.835089,17.8615385 4.288986,17.8615385 L15.51096,17.8615385 C15.96483,17.8615385 16.34769,17.5261881 16.40403,17.0792031 L17.88048,5.35846154 Z M3.336372,0.784728831 C3.842721,0.282274823 4.529475,0 5.24556,0 L14.55435,0 C15.27048,0 15.95727,0.282274823 16.46361,0.784728831 L18.91386,3.21617541 C19.18287,3.4831161 19.38834,3.79963149 19.52235,4.14276058 C19.68174,4.55096818 19.73997,4.99722085 19.68381,5.44299127 L18.19008,17.3007755 C18.02124,18.6415518 16.87266,19.6476923 15.51096,19.6476923 L4.288986,19.6476923 C2.927313,19.6476923 1.778724,18.6415518 1.60983,17.3007755 L0.116118,5.44299127 C0.059967,4.99722085 0.118251,4.55095925 0.277614,4.14276058 C0.411579,3.79963149 0.617067,3.4831161 0.886077,3.21616648 L3.336372,0.784728831 Z M6.299973,7.14461538 C6.797034,7.14461538 7.199973,7.54446378 7.199973,8.03769231 L7.199973,8.93076923 C7.199973,10.4105084 8.40879,11.61 9.9,11.61 C11.39112,11.61 12.6,10.4105084 12.6,8.93076923 L12.6,8.03769231 C12.6,7.54446378 13.00293,7.14461538 13.5,7.14461538 C13.99707,7.14461538 14.4,7.54446378 14.4,8.03769231 L14.4,8.93076923 C14.4,11.3969118 12.38526,13.3961538 9.9,13.3961538 C7.414695,13.3961538 5.399973,11.3969118 5.399973,8.93076923 L5.399973,8.03769231 C5.399973,7.54446378 5.802921,7.14461538 6.299973,7.14461538 Z"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "cart-icon",
};
</script>
